/** Tab labels for the asset modal family. Figma names the colour tab "Slider"
 *  after the picker widget; keeping the labels here means the visible name has
 *  one definition rather than one per modal (and per empty-state string that
 *  points the user at a tab). */
export const TAB_LABEL = {
  assets: "Assets",
  image: "Image",
  color: "Slider",
} as const;

export const EMPTY_MESSAGE = {
  /** Assets tab of a modal that accepts any asset type. */
  anyAsset: `No saved assets yet. Add one from the ${TAB_LABEL.image} or ${TAB_LABEL.color} tab.`,
  /** Assets tab of a modal that only accepts images. */
  imageAsset: `No image assets yet. Upload one from the ${TAB_LABEL.image} tab.`,
  /** Asset picker used to choose a colour. */
  colorAsset: `No saved colors yet. Save one from the ${TAB_LABEL.color} tab to use it here.`,
} as const;
